var _style, _g, _path, _path2, _path3, _path4, _g2, _path5, _g3, _path6, _path7, _path8, _g4, _g5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSchoolLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "150 -188 500 500",
    style: {
      enableBackground: "new 150 -188 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#XMLID_12_);}\n\t.st1{fill:url(#XMLID_13_);}\n\t.st2{fill:url(#XMLID_14_);}\n\t.st3{fill:url(#XMLID_15_);}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:url(#XMLID_17_);}\n\t.st6{fill:url(#XMLID_18_);}\n\t.st7{fill:url(#XMLID_24_);}\n\t.st8{fill:url(#XMLID_27_);}\n\t.st9{fill:#2E8254;}\n\t.st10{font-family:'Cabin-Medium';}\n\t.st11{font-size:53px;}\n\t.st12{fill:#313A35;}\n\t.st13{font-size:30px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.0175,
    y1: 60.3422,
    x2: 420.1403,
    y2: 216.9115,
    gradientTransform: "matrix(1 0 0 -1 0 123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2BA66D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1931,
    style: {
      stopColor: "#6BDF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8218,
    style: {
      stopColor: "#AEF484"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M450.1-43.3c-2.3-23.8-12.9-46.7-31.5-68.1c-0.4-0.5-1-0.8-1.6-0.8s-1.1,0.2-1.5,0.5 c-0.4,0.4-0.7,0.9-0.8,1.5c0,0.6,0.1,1.2,0.5,1.6c32.5,37.4,39.5,78.4,20.8,121.7c-10.6,24.6-27,43.1-34.4,50.7 c-1.6-13.5-4.1-49.7,7.6-83.1c14.9-42.5,16.4-52.6,11.6-77.5c-0.2-1-1.1-1.8-2.2-1.8c-0.1,0-0.3,0-0.4,0c-1.2,0.2-2,1.4-1.8,2.6 c4.4,23,4,31.3-11.4,75.2c-11.1,31.7-9.7,65.6-8.2,81.6c-10.6-14.7-31.3-49.7-20.2-86.1c5.4-17.7,13.2-27.5,20-36.1 c8.9-11.2,16.6-21,15.6-43c-0.1-1.2-1.1-2.2-2.3-2.1c-0.6,0-1.1,0.3-1.5,0.7c-0.4,0.4-0.6,1-0.6,1.6c1,20.4-5.9,29-14.6,40 c-7.1,9-15.2,19.1-20.8,37.6c-8,26.1-0.2,51.3,7.7,67.8c6.3,13.1,13.6,23,17.1,27.3c-0.2,0.7-0.1,1.6,0.4,2.2 c0.3,0.3,0.7,0.6,1.2,0.7c0.4,0.3,0.9,0.5,1.4,0.5c0.1,0,0.3,0,0.4,0c0.2,0,0.5-0.1,0.7-0.2c0.4-0.1,0.8-0.3,1.1-0.5 c0.7-0.6,0.9-1.5,0.6-2.3c6.4-6.3,25.2-26.2,37.2-53.8C448.6-4.6,452-24.3,450.1-43.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.9,
    y1: 69.15,
    x2: 401.3768,
    y2: 69.15,
    gradientTransform: "matrix(1 0 0 -1 0 123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1782,
    style: {
      stopColor: "#AEF484"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8069,
    style: {
      stopColor: "#6BDF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BA66D"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st1",
    d: "M401.2,71.7c-0.1-0.3-12.8-31-51.4-37.8c-3.8-0.7-7.7-1-12.1-1c-12.4,0-25.2,2.8-37.5,5.4 c-12,2.6-23.3,5-33.7,5c-11.3,0-19.8-2.8-26.8-8.9c-0.4-0.4-1-0.6-1.5-0.6c-0.7,0-1.3,0.3-1.7,0.8c-0.4,0.5-0.6,1.1-0.6,1.7 c0,0.6,0.3,1.2,0.8,1.6c7.9,6.9,17.4,10.1,29.7,10.1c10.9,0,22.5-2.5,34.8-5.2c12.1-2.6,24.7-5.3,36.6-5.3c4,0,7.7,0.3,11.2,0.9 c35.9,6.3,47.8,34.7,47.9,35c0.4,0.9,1.2,1.4,2.1,1.4c0.3,0,0.6-0.1,0.9-0.2C401.1,74.2,401.7,72.9,401.2,71.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.75,
    y1: 69.1,
    x2: 566.2,
    y2: 69.1,
    gradientTransform: "matrix(1 0 0 -1 0 123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2BA66D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1931,
    style: {
      stopColor: "#6BDF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8218,
    style: {
      stopColor: "#AEF484"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st2",
    d: "M565.6,34.6c-0.4-0.5-1.1-0.8-1.7-0.8c-0.6,0-1.1,0.2-1.5,0.6c-7,6.1-15.5,8.9-26.8,8.9 c-10.5,0-21.8-2.4-33.7-5c-12.4-2.7-25.2-5.4-37.5-5.4c-4.3,0-8.3,0.3-12.1,1c-38.6,6.8-51.2,37.5-51.4,37.8 c-0.2,0.6-0.2,1.2,0,1.8c0.2,0.6,0.7,1,1.3,1.2c0.3,0.1,0.6,0.2,0.9,0.2c0.9,0,1.8-0.6,2.1-1.4c0.1-0.3,12-28.7,47.9-35 c3.5-0.6,7.2-0.9,11.2-0.9c11.9,0,24.4,2.7,36.6,5.3c12.3,2.6,23.9,5.2,34.8,5.2c12.2,0,21.9-3.3,29.7-10.1 c0.5-0.4,0.7-1,0.8-1.6C566.2,35.7,566,35.1,565.6,34.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.1,
    y1: 55.7936,
    x2: 400.1,
    y2: 55.7936,
    gradientTransform: "matrix(1 0 0 -1 0 123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1782,
    style: {
      stopColor: "#AEF484"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8069,
    style: {
      stopColor: "#6BDF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BA66D"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st3",
    d: "M226.1,89.1c0,0,3-14.4,3.3-29.1c0,0,32.7,3.7,61.1-5.3s76.2-22.4,109.6,19.7l-14,14.7H226.1z "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st4",
    d: "M248.2,74.7c0,0,2.1-0.1,5.7-0.3c3.6-0.2,8.8-0.6,15-1.2c3.1-0.3,6.5-0.7,10-1.1 s7.3-1,11.1-1.5c1.9-0.3,3.9-0.6,5.8-1c2-0.4,3.9-0.7,5.9-1.1c1-0.2,2-0.4,3-0.6c1-0.2,2-0.5,3-0.7c2-0.5,4.1-0.9,6.1-1.4 c1-0.2,2-0.5,3.1-0.7c1.1-0.2,2.1-0.4,3.2-0.5c2.1-0.4,4.2-0.6,6.3-0.9c2.1-0.3,4.2-0.3,6.2-0.5c2-0.1,4.1-0.1,6.1-0.1 c4,0.1,7.8,0.3,11.5,0.8c3.6,0.4,7,1.2,10.1,2c1.5,0.4,3,0.9,4.4,1.3c1.4,0.5,2.6,1,3.8,1.5c1.2,0.5,2.3,1,3.3,1.5 s1.9,1,2.7,1.4c1.6,0.9,2.8,1.7,3.6,2.3c0.8,0.6,1.2,0.9,1.2,0.9s-0.5-0.2-1.4-0.6c-0.4-0.2-1-0.5-1.6-0.8 c-0.7-0.3-1.4-0.6-2.2-0.9c-1.7-0.7-3.8-1.4-6.2-2.1c-1.2-0.4-2.5-0.7-3.9-1s-2.8-0.6-4.3-0.9c-1.5-0.2-3.1-0.6-4.7-0.7 c-0.8-0.1-1.7-0.2-2.5-0.3s-1.7-0.1-2.6-0.2c-3.5-0.3-7.2-0.3-11-0.2c-1.9,0.1-3.9,0.2-5.8,0.4c-1,0.1-2,0.2-3,0.3l-1.5,0.1 l-1.5,0.2c-2,0.3-4,0.5-6,0.9l-3,0.5c-1,0.2-2,0.5-3,0.7c-2,0.4-4.1,0.9-6.1,1.3c-1,0.2-2.1,0.4-3.1,0.7c-1,0.2-2.1,0.4-3.1,0.6 s-2,0.4-3.1,0.5c-1,0.1-2,0.3-3,0.4c-2,0.3-4,0.5-6,0.8c-3.9,0.5-7.7,0.7-11.3,0.9c-3.6,0.2-7,0.3-10.2,0.3c-3.1,0-6,0-8.6-0.1 s-4.8-0.3-6.6-0.4C250.2,75.1,248.2,74.7,248.2,74.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.1,
    y1: 55.7936,
    x2: 574.1,
    y2: 55.7936,
    gradientTransform: "matrix(1 0 0 -1 0 123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2BA66D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1931,
    style: {
      stopColor: "#6BDF94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8218,
    style: {
      stopColor: "#AEF484"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st5",
    d: "M574.1,89.1c0,0-3-14.4-3.3-29.1c0,0-32.7,3.7-61.1-5.3c-28.4-9-76.2-22.4-109.6,19.7 l14,14.7H574.1z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st4",
    d: "M552,74.7c0,0-2.1,0.3-5.7,0.6c-1.8,0.1-4,0.3-6.6,0.4c-2.6,0.1-5.4,0.2-8.6,0.1 c-3.1,0-6.6-0.1-10.2-0.3c-3.6-0.2-7.4-0.5-11.3-0.9c-2-0.2-4-0.5-6-0.8c-1-0.1-2-0.3-3-0.4c-1-0.2-2-0.4-3.1-0.5 c-1-0.2-2-0.4-3.1-0.6c-1-0.2-2-0.4-3.1-0.7c-2-0.4-4.1-0.9-6.1-1.3c-1-0.2-2-0.5-3-0.7l-3-0.5c-2-0.4-4-0.6-6-0.9l-1.5-0.2 l-1.5-0.1c-1-0.1-2-0.2-3-0.3c-2-0.2-3.9-0.3-5.8-0.4c-3.8,0-7.5-0.1-11,0.2c-0.9,0.1-1.7,0.1-2.6,0.2c-0.8,0.1-1.7,0.2-2.5,0.3 c-1.7,0.1-3.2,0.5-4.7,0.7c-1.5,0.3-2.9,0.6-4.3,0.9c-1.4,0.4-2.7,0.6-3.9,1c-2.4,0.7-4.5,1.4-6.2,2.1c-0.8,0.4-1.6,0.7-2.2,0.9 c-0.7,0.3-1.2,0.6-1.6,0.8c-0.9,0.4-1.4,0.6-1.4,0.6s0.4-0.3,1.2-0.9c0.8-0.6,2-1.4,3.6-2.3c0.8-0.5,1.7-0.9,2.7-1.4 s2.1-1,3.3-1.5c1.2-0.5,2.5-1,3.8-1.5c1.4-0.4,2.8-0.9,4.4-1.3c3.1-0.8,6.4-1.6,10.1-2c3.6-0.5,7.5-0.8,11.5-0.8 c2,0,4,0,6.1,0.1c2,0.2,4.1,0.2,6.2,0.5s4.2,0.5,6.3,0.9c1.1,0.2,2.1,0.4,3.2,0.5c1,0.2,2,0.4,3.1,0.7c2,0.5,4.1,0.9,6.1,1.4 c1,0.2,2,0.5,3,0.7c1,0.2,2,0.4,3,0.6c2,0.4,4,0.8,5.9,1.1c2,0.4,3.9,0.7,5.8,1c3.8,0.6,7.5,1.1,11.1,1.5 c3.5,0.4,6.9,0.8,10,1.1c6.2,0.6,11.4,1,15,1.2C549.9,74.6,552,74.7,552,74.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_49_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.4,
    y1: 26.9,
    x2: 581.5,
    y2: 26.9,
    gradientTransform: "matrix(1 0 0 -1 0 123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0049505,
    style: {
      stopColor: "#1A242D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    style: {
      stopColor: "#194A3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A242D"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st6",
    d: "M400.2,106.8c-8.5,0-15.6-6-17.3-14H222.1c-2,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7h167.7 v3.7c0,5.7,4.6,10.3,10.3,10.3c5.7,0,10.3-4.6,10.3-10.3v-3.7h167.4c2,0,3.7,1.7,3.7,3.7s-1.7,3.7-3.7,3.7H417.5 C415.8,100.8,408.7,106.8,400.2,106.8z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.3706,
    y1: 118.8986,
    x2: 367.8732,
    y2: 93.0458,
    gradientTransform: "matrix(1 0 0 -1 0 123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2277,
    style: {
      stopColor: "#AEF484"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6BDF94"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st7",
    d: "M364.5,30.3c0,0,4.6-23.2-30.2-25.5C334.3,4.7,338.5,32.6,364.5,30.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 516.2477,
    y1: 118.8978,
    x2: 553.7504,
    y2: 93.045,
    gradientTransform: "matrix(-1 0 0 -1 994.6761 123)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2277,
    style: {
      stopColor: "#AEF484"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6BDF94"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st8",
    d: "M444.3,30.3c0,0-4.6-23.2,30.2-25.5C474.5,4.7,470.3,32.6,444.3,30.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_21_",
    transform: "matrix(1 0 0 1 247.2363 156.1653)",
    className: "st9 st10 st11"
  }, "GREEN"), /*#__PURE__*/React.createElement("text", {
    id: "XMLID_22_",
    transform: "matrix(1 0 0 1 422.2906 156.1653)",
    className: "st9 st10 st11"
  }, "FIELD")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_11_",
    transform: "matrix(1 0 0 1 279.312 195.1653)",
    className: "st12 st10 st13"
  }, "A Great Place To Be")))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolLogo);
export default __webpack_public_path__ + "static/media/school_logo.93991c75fed7c3118b330a3c9402abcf.svg";
export { ForwardRef as ReactComponent };